export const nextApiRoutes = {
    receiveEvents: () => '/api/modulr/receive-events',
}
